import { render, staticRenderFns } from "./AddVariancePopup.vue?vue&type=template&id=8573f33c"
import script from "./AddVariancePopup.vue?vue&type=script&lang=js"
export * from "./AddVariancePopup.vue?vue&type=script&lang=js"
import style0 from "./AddVariancePopup.vue?vue&type=style&index=0&id=8573f33c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports